import { Badge } from "@/components/ui/badge";
import { BOOKING_STATUSES, bookingMissingFields, isBookingIncomplete, STATUS_BADGE_CLASS } from "@/lib/constants";

const LIFECYCLE_STYLE = {
  upcoming:      "bg-slate-100 text-slate-600",
  arrive_window: "bg-emerald-100 text-emerald-700",
  on_time:       "bg-emerald-100 text-emerald-700",
  late:          "bg-amber-100 text-amber-700",
  overdue:       "bg-orange-100 text-orange-800",
  missed:        "bg-rose-100 text-rose-700",
};

// Status badge plus on-hold / incomplete / lifecycle chips.
export default function BookingStatusCell({ row: r, lifecycle }) {
  const meta = BOOKING_STATUSES.find((s) => s.value === r.status);
  const lc = lifecycle.get(r.id);
  return (
    <>
      <Badge variant="secondary" className={STATUS_BADGE_CLASS[meta?.tone || "slate"]}>
        {meta?.label || r.status}
      </Badge>
      {r.on_hold && (
        <Badge className="ml-1 text-[10px] bg-rose-100 text-rose-700" data-testid={`booking-on-hold-${r.id}`}>On hold</Badge>
      )}
      {isBookingIncomplete(r) && (
        <Badge className="ml-1 text-[10px] bg-amber-100 text-amber-700" data-testid={`booking-incomplete-${r.id}`}
               title={`Missing: ${bookingMissingFields(r).join(", ")}`}>
          Incomplete
        </Badge>
      )}
      {lc && lc.lifecycle_state in LIFECYCLE_STYLE && (
        <Badge className={`ml-1 text-[10px] ${LIFECYCLE_STYLE[lc.lifecycle_state]}`} data-testid={`booking-lifecycle-${r.id}`}>
          {lc.lifecycle_state.replace("_", " ")}
        </Badge>
      )}
    </>
  );
}
